<template>
  <!--自助门禁   登录-->
  <div>
    <dl class="dl_type">
      <dt :class="tabid == 0 ? 'sel' : ''" @click="tabid = 0">密码登录</dt>
      <dt :class="tabid == 1 ? 'sel' : ''" @click="tabid = 1">验证码登录</dt>
    </dl>
    <ul class="pz_one" v-if="tabid == 0">
      <li>
        <input
          v-model="formData.account"
          type="text"
          class="txt"
          placeholder="请输入登录账号"
        />
      </li>
      <li>
        <input
          v-model="formData.password"
          type="password"
          class="txt"
          placeholder="请输入登录密码"
        />
      </li>
      <li>
        <button class="btnNext" @click="login">登 录</button>
      </li>
    </ul>
    <ul class="pz_one" v-if="tabid == 1">
      <li><input type="text" class="txt" placeholder="请输入手机号码" /></li>
      <li>
        <input type="text" class="txt" placeholder="请输入验证码" />
        <button class="getYzm">获取验证码</button>
      </li>
      <li>
        <button class="btnNext" @click="bindNext()">登 录</button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  data() {
    return {
      tabid: 0,
      formData: {
        account: "",
        password: "",
        loginClientType: 4,
        alias: this.$route.query.alias,
      },
    };
  },
  methods: {
    bindNext() {
      this.$router.push("/accessControl/location");
    },
    async login() {
      const { account, password, alias } = this.formData;
      if (account === "" || !account) {
        this.$message.warning("请输入账号");
        return;
      }
      if (password === "" || !password) {
        this.$message.warning("请输入密码");
        return;
      }
      const res = await this.$post("/api/AccessControl/Login", this.formData);
      if (res.code === 200) {
        // 这里使用session，方便用户随时切换登录
        sessionStorage.setItem("accessToken", res.data.token);
        this.$router.push(`/access-control/location?alias=${alias}`);
      }
    },
  },
};
</script>

<style></style>
